import React, { Component } from "react";
import PropTypes from "prop-types";

import QuizInput from "components/shared/Inputs/QuizInput";

import localize from "lang/localize";

const propTypes = {
  isConfirmationChallenge: PropTypes.bool,
  options: PropTypes.array.isRequired,
  multiSelect: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  showAlertWithTimeout: PropTypes.func.isRequired,
  submitted: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  handleOpenClaimLoginDialog: PropTypes.func.isRequired,
  language: PropTypes.string
};

const defaultProps = {
  multiSelect: false
};

class QuizChallenge extends Component {
  constructor() {
    super();
    this.state = {
      selected: []
    };
  }

  renderOptions() {
    return this.props.options.map(option => (
      <QuizInput
        key={option.id}
        id={option.id}
        selected={this.state.selected.indexOf(option.id) !== -1}
        image={option.image}
        title={option.title}
        onClick={
          this.props.isLoggedIn
            ? id => this.handleClick(id)
            : this.props.handleOpenClaimLoginDialog
        }
        disabled={!this.props.isLoggedIn}
      />
    ));
  }

  handleClick(id) {
    if (this.props.multiSelect) {
      let idx = this.state.selected.indexOf(id);
      let selectedcopy = this.state.selected.slice();
      if (idx === -1) {
        selectedcopy.push(id);
      } else {
        selectedcopy.splice(idx, 1);
      }
      this.setState({ selected: selectedcopy });
    } else {
      if (this.state.selected[0] === id) {
        this.setState({ selected: [] });
      } else {
        this.setState({ selected: [id] });
      }
    }
  }

  handleConfirmationClick(id) {
    this.setState({ selected: [id] }, function() {
      let query = { quiz_option_id: this.state.selected[0] };
      this.props.handleSubmit(query);
      this.setState({ selected: [] });
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.state.selected.length === 0) {
      this.props.showAlertWithTimeout({
        text: localize("choose_option_to_claim_text", this.props.language),
        type: "error"
      });
      return;
    }
    let query;
    if (this.props.multiSelect) {
      let quiz_option_id_list = this.state.selected.map(entry => ({
        id: entry
      }));
      query = { quiz_option_id_list: JSON.stringify(quiz_option_id_list) };
    } else {
      query = { quiz_option_id: this.state.selected[0] };
    }
    this.props.handleSubmit(query);
    this.setState({ selected: [] });
  }

  render() {
    /* Confirmation Challenge */
    if (this.props.isConfirmationChallenge) {
      return (
        <div className="pure-g">
          <div className="pure-u-sm-4-24" />
          <div className="pure-u-1 pure-u-sm-16-24 textcenter">
            {this.props.isLoggedIn ? (
              this.props.options.map(option => (
                <QuizInput
                  key={option.id}
                  id={option.id}
                  selected={this.state.selected.indexOf(option.id) !== -1}
                  image={option.image}
                  title={option.title}
                  onClick={id => {
                    this.handleConfirmationClick(id);
                  }}
                  isConfirmationChallenge={this.props.isConfirmationChallenge}
                />
              ))
            ) : (
              <div>
                {this.props.options.map(option => (
                  <QuizInput
                    key={option.id}
                    id={option.id}
                    selected={this.state.selected.indexOf(option.id) !== -1}
                    image={option.image}
                    title={option.title}
                    onClick={this.props.handleOpenClaimLoginDialog}
                    isConfirmationChallenge={this.props.isConfirmationChallenge}
                  />
                ))}
              </div>
            )}
          </div>
          <div className="pure-u-sm-4-24" />
        </div>
      );
      /* Not Confirmation Challenge */
    } else {
      return (
        <div className="pure-g">
          <div className="pure-u-sm-4-24" />
          <div className="pure-u-1 pure-u-sm-16-24">
            {this.renderOptions()}
            {this.props.isLoggedIn ? (
              <button
                className={
                  "button automargin " +
                  (this.props.submitted ? "inactive" : "cta")
                }
                onClick={this.handleSubmit.bind(this)}
                disabled={this.props.submitted}
                id="submitCompletionButton"
              >
                {this.props.submitted
                  ? localize("button_claim_submitting", this.props.language)
                  : localize("button_claim_get_points", this.props.language)}
              </button>
            ) : (
              <button
                className={
                  "button automargin " +
                  (this.props.submitted ? "inactive" : "cta")
                }
                onClick={this.props.handleOpenClaimLoginDialog}
                disabled={this.props.submitted}
                id="loginBeforeSubmitCompletionButton"
              >
                {this.props.submitted
                  ? localize("button_claim_submitting", this.props.language)
                  : localize("button_claim_get_points", this.props.language)}
              </button>
            )}
          </div>
          <div className="pure-u-sm-4-24" />
        </div>
      );
    }
  }
}

QuizChallenge.propTypes = propTypes;
QuizChallenge.defaultProps = defaultProps;

export default QuizChallenge;
